import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { baseUrl } from "../../Config/config";

import axios from "axios";
import config from "../config/config";

function getOptions(url) {
  let options = {};
  if (window.location.pathname == "/") {
    localStorage.clear();
    return {};
  } else if (localStorage.getItem("token") != null) {
    return {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
  }
}
const axiosBaseQuery =
  ({ baseUrl, header } = { baseUrl: "" }) =>
  async ({ url, method, data, params, headers }) => {
    console.log(baseUrl + url);
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: getOptions(url),
      });
      if (result && result != null && result.data != null) {
        return { data: result.data, status: result.status };
      } else {
        return { data: result.data, status: result.status };
      }
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseUrl,
  }),
  endpoints: (builder) => ({}),
});

export default apiSlice;
